import React, { useState } from 'react'

import { useTranslation } from 'i18n'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'

import PaginatedItems from 'templates/components/PaginatedItems'
import LoadingContainer from 'components/Spinner2'

// UGC is kept in a different bucket than site assets, so these helpers don't help
// import LegacyRetinaImage from "components/LegacyRetinaImage"
// import {legacyImageURL} from "components/LegacyImage"

const GalleryScreen = ({
  items,
  currentPage,
  totalPages,
  isLoading,
  onPageClick,
}) => {
  const { t } = useTranslation('common')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [detailUrl, setDetailUrl] = useState(false)

  const handlePaginatedItemClick = clickedPageNumber => {
    console.log(`handlePaginatedItemClick`, clickedPageNumber)
    onPageClick(clickedPageNumber)
  }

  const handleItemClick = url => {
    setDetailUrl(url)
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <div className="step-screen gallery-screen">
        <LoadingContainer condition={isLoading}>
          <div className={`gallery-list ${isLoading ? 'is--loading' : 'off'}`}>
            {items.map((item, i) => {
              // return <LegacyRetinaImage key={i} image={{id: item.id, alt: ''}} />
              // <img src={legacyImageURL({id: item.id})} />
              //
              return (
                <div
                  className="gallery-item"
                  key={i}
                  role="button"
                  onClick={() => {
                    handleItemClick(item)
                  }}
                >
                  <img src={item} />
                </div>
              )
            })}
          </div>
          <PaginatedItems
            className={`gallery-pagination`}
            currentPage={currentPage}
            numPages={totalPages}
            onClick={handlePaginatedItemClick}
          />
        </LoadingContainer>
        <Modal
          tabIndex={0}
          className={'0'}
          open={isModalOpen}
          onClose={closeModal}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
        >
          <div className={`gallery-modal on`}>
            <div className="gallery-modal-container">
              <img src={`${detailUrl}`} />
            </div>
            <button
              className={`modal-close top-level-close`}
              onClick={closeModal}
              aria-label={t('close')}
            ></button>
          </div>
        </Modal>
      </div>
    </>
  )
}
export default GalleryScreen
